export default __webpack_public_path__ + "static/media/bg-light.5ad46f26.png";